import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLogPfpEdit } from "@/entities/IProfile";
import { getScaledImageUri, ImageScale } from "@/helpers/image.helpers";
import Image from "next/image";
import ProfileActivityLogItemAction from "./utils/ProfileActivityLogItemAction";
export default function ProfileActivityLogPfp(t0) {
  const $ = _c(14);
  const {
    log
  } = t0;
  const isAdded = !log.contents.old_value;
  const t1 = isAdded ? "added" : "changed";
  let t2;
  if ($[0] !== t1) {
    t2 = <ProfileActivityLogItemAction action={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-whitespace-nowrap tw-text-base tw-text-iron-300 tw-font-medium">profile picture</span>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== isAdded || $[4] !== log.contents.old_value) {
    t4 = !isAdded && <><div className="tw-pl-1">{log.contents.old_value && <Image unoptimized={true} src={getScaledImageUri(log.contents.old_value, ImageScale.W_AUTO_H_50)} alt="Profile picture" width="20" height="20" className="tw-flex-shrink-0 tw-object-contain tw-max-h-10 tw-min-w-10 tw-w-auto tw-h-auto tw-rounded-sm tw-ring-2 tw-ring-white/30 tw-bg-iron-800" />}</div><svg className="tw-flex-shrink-0 tw-h-5 tw-w-5 tw-text-iron-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 12H20M20 12L14 6M20 12L14 18" stroke="currentcOLOR" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></>;
    $[3] = isAdded;
    $[4] = log.contents.old_value;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== log.contents.new_value) {
    t5 = getScaledImageUri(log.contents.new_value, ImageScale.W_AUTO_H_50);
    $[6] = log.contents.new_value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <div className="tw-ml-2"><Image unoptimized={true} src={t5} alt="Profile picture" width="20" height="20" className="tw-flex-shrink-0 tw-object-contain tw-max-h-10 tw-min-w-10 tw-w-auto tw-h-auto tw-rounded-sm tw-ring-2 tw-ring-white/30 tw-bg-iron-800" /></div>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t4 || $[12] !== t6) {
    t7 = <>{t2}{t3}{t4}{t6}</>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
}